const config = [
  { propName: 'currentJob', reducerName: 'currentJob' },
  { propName: 'hiringTeam', reducerName: 'hiringTeam' },
  { propName: 'updatedHiringTeam', reducerName: 'updatedHiringTeam' },
  { propName: 'getOffices', reducerName: 'getOffices' },
  { propName: 'getJobPost', reducerName: 'getJobPost' },
  { propName: 'defaultJobPost', reducerName: 'defaultJobPost' },
  { propName: 'getInterviewPlan', reducerName: 'getInterviewPlan' },
  { propName: 'getInterviewPools', reducerName: 'getInterviewPools' },
  { propName: 'getHackerrankStatus', reducerName: 'getHackerrankStatus' },
];

export const getAtsJobCreate = (state) => {
  const atsJob = {};

  config.forEach(({ propName, reducerName }) => {
    atsJob[propName] = state?.atsJobCreate?.[reducerName];
  });

  return atsJob;
};
